<template>
  <div style="background-color: #ffffff">
    <el-button @click="exportPDF()" type="primary" class="btn"> 导出</el-button>
    <div class='graphList'>
      <div id='AGPgraph' class='graph'></div>
      <div id='AGP19graph' class='graph'></div>
      <div id='TIRComparison' class='graph'></div>
      <div id='TBRComparison' class='graph'></div>
      <div id="TIRDistribution" class='graph'></div>
      <div id="A1CDistribution" class='graph'></div>
    </div>
  </div>
</template>
<script>
import * as echarts from 'echarts'
import html2canvas from "html2canvas";
import jsPDF from "jspdf"

export default {
  name: 'HCLprint',
  data () {
    return {
      sgMax: 25,
      sel_time: new Date(2019, 0, 1).getTime(),
      AGPGraphList: {
        'open': {
          'Q1Data': new Array(144),
          'midData': new Array(144),
          'Q2Data': new Array(144)
        },
        'close': {
          'Q1Data': new Array(144),
          'midData': new Array(144),
          'Q2Data': new Array(144)
        }
      },
      TIRComparisonList: {
        'open': {
          'Q1Data': new Array(),
          'midData': new Array(),
          'Q2Data': new Array(),
          'avgData': new Array(),
        },
        'close': {
          'Q1Data': new Array(),
          'midData': new Array(),
          'Q2Data': new Array(),
          'avgData': new Array(),
        }
      },
      TBRComparisonList: {
        'open': {
          'Q1Data': new Array(),
          'midData': new Array(),
          'Q2Data': new Array(),
          'avgData': new Array(),
        },
        'close': {
          'Q1Data': new Array(),
          'midData': new Array(),
          'Q2Data': new Array(),
          'avgData': new Array(),
        }
      },
      TIRDistributionList: {
        'open': new Array(),
        'close': new Array()
      },
      A1CDistributionList: {
        'open': new Array(),
        'close': new Array()
      },
    }
  },
  methods: {
    drawAGPGraph () {
      const id = 'AGPgraph'
      let XTimeMin = this.sel_time;
      let XTimeMax = this.sel_time + 86400 * 1000;
      this.AGPgraphChart = echarts.init(document.getElementById(id))
      this.AGPgraphChart.setOption({
        xAxis: [{
          type: 'time',
          interval: 3600 * 1000,
          min: XTimeMin,
          max: XTimeMax,
          splitNumber: 24,
          name: 'Hour of Day',
          nameGap: 25,
          nameTextStyle: {
            fontSize: 12,
            color: 'black'
          },
          axisLabel: {
            showMaxLabel: true,
            margin: 10, textStyle: { color: '#282828', baseline: 'middle' },
            formatter: function (value, index) {
              index = (value - XTimeMin) / 3600000;
              let H = index;
              if (index < 24) {
                if (index % 3 === 0) {
                  H = H < 10 ? ('0' + H + ':00') : H + ':00';
                  return H;
                } else {
                  return ' ';
                }
              } else {
                return '24:00';
              }
            }
          },
          nameLocation: 'middle',
        }],
        yAxis: [
          {
            type: 'value',
            min: 0,
            max: this.sgMax,
            show: true,
            name: 'Sensor Glucose [mmol/L]',
            nameLocation: 'middle',
            nameTextStyle: {
              color: '#282828',
              fontSize: 12
            },
            axisLabel: {
              margin: 1,
              textStyle: { color: '#282828', baseline: 'middle' }
            },
            splitLine: {
              show: false
            },
          },
        ],
        grid: {
          show: true,
          borderColor: 'black'
        },
        legend: {
          top: '15%',
          right: '10%',
          orient: 'vertical',
          itemHeight: 5,
          itemStyle: {
            borderWidth: 2,
            borderType: 'solid',
          },
          formatter: function (name) {
            let nameLegendMap = new Map([
              ['50%', 'Median Glucose Standard Therapy'],
              ['close50%', 'Median Glucose Hybrid Closed-Loop'],
              ['75%', '25%-75% Distribution Standard Therapy'],
              ['close75%', '25%-75% Distribution Hybrid Closed-Loop']
            ])
            return nameLegendMap.get(name)
          },

          data: [
            {
              name: 'close75%', icon: 'rect', itemStyle: { color: '#8caabe' }
            },
            {
              name: '75%', icon: 'rect', itemStyle: { color: '#f5999a' }
            },
            {
              name: 'close50%',
            },
            {
              name: '50%'
            },

          ],
        },
        series: [
          // 开环25%
          {
            name: '25%',
            type: 'line',
            data: this.AGPGraphList['open']['Q1Data'],
            stack: 'open',
            lineStyle: {
              normal: {
                color: '#f5999a',
                width: 1
              }
            },
            symbol: 'none',
            markLine: {
              data: [{ yAxis: 3.9 }, { yAxis: 10 }],
              silent: true,
              symbol: ['circle', 'circle'],
              symbolSize: 1,
              lineStyle: {
                normal: {
                  color: 'black',
                  type: [5, 10],
                  dashOffset: 5,
                  width: 1,
                }
              },
              label: { normal: { show: false } },
            },
          },
          // 开环50%
          {
            name: '50%',
            type: 'line',
            data: this.AGPGraphList['open']['midData'],
            lineStyle: {
              normal: {
                color: '#f5999a',
                width: 2
              }
            },
            symbol: 'none',
          },
          // 开环75%
          {
            name: '75%',
            type: 'line',
            data: this.AGPGraphList['open']['Q2Data'],
            stack: 'open',
            areaStyle: { normal: { color: '#f5999a', } },
            lineStyle: {
              normal: {
                color: '#f5999a',
                width: 1
              }
            },
            symbol: 'none',
          },
          // 闭环25%
          {
            name: 'close25%',
            type: 'line',
            data: this.AGPGraphList['close']['Q1Data'],
            stack: 'close',
            lineStyle: {
              normal: {
                color: '#8caabe',
                width: 1
              }
            },
            symbol: 'none',
          },
          // 闭环50%
          {
            name: 'close50%',
            type: 'line',
            data: this.AGPGraphList['close']['midData'],
            lineStyle: {
              normal: {
                color: '#8caabe',
                width: 2,
                type: 'dashed'
              }
            },
            symbol: 'none',
          },
          // 闭环75%
          {
            name: 'close75%',
            type: 'line',
            data: this.AGPGraphList['close']['Q2Data'],
            stack: 'close',
            areaStyle: { normal: { color: '#8caabe', } },
            lineStyle: {
              normal: {
                color: '#8caabe',
                width: 1
              }
            },
            symbol: 'none',
          },

        ]
      })

    },
    drawAGP19Graph () {
      const id = 'AGP19graph'
      let XTimeMin = this.sel_time;
      let XTimeMax = this.sel_time + 86400 * 1000;
      this.AGP19graphChart = echarts.init(document.getElementById(id))
      this.AGP19graphChart.setOption({
        xAxis: [{
          type: 'time',
          interval: 3600 * 1000,
          min: XTimeMin,
          max: XTimeMax,
          splitNumber: 24,
          name: 'Hour of Day',
          nameGap: 25,
          nameTextStyle: {
            fontSize: 12,
            color: 'black'
          },
          axisLabel: {
            showMaxLabel: true,
            margin: 10, textStyle: { color: '#282828', baseline: 'middle' },
            formatter: function (value, index) {
              index = (value - XTimeMin) / 3600000;
              let H = index;
              if (index < 24) {
                if (index % 3 === 0) {
                  H = H < 10 ? ('0' + H + ':00') : H + ':00';
                  return H;
                } else {
                  return ' ';
                }
              } else {
                return '24:00';
              }
            }
          },
          nameLocation: 'middle',
        }],
        yAxis: [
          {
            type: 'value',
            min: 0,
            max: this.sgMax,
            show: true,
            name: 'Sensor Glucose [mmol/L]',
            nameLocation: 'middle',
            nameTextStyle: {
              color: '#282828',
              fontSize: 12
            },
            axisLabel: {
              margin: 1,
              textStyle: { color: '#282828', baseline: 'middle' }
            },
            splitLine: {
              show: false
            },
          },
        ],
        grid: {
          show: true,
          borderColor: 'black'
        },
        legend: {
          top: '15%',
          right: '10%',
          orient: 'vertical',
          itemHeight: 5,
          itemStyle: {
            borderWidth: 2,
            borderType: 'solid',
          },
          formatter: function (name) {
            let nameLegendMap = new Map([
              ['50%', 'Median Glucose Standard Therapy'],
              ['close50%', 'Median Glucose Hybrid Closed-Loop'],
              ['90%', '10%-90% Distribution Standard Therapy'],
              ['close90%', '10%-90% Distribution Hybrid Closed-Loop']
            ])
            return nameLegendMap.get(name)
          },

          data: [
            {
              name: 'close90%', icon: 'rect', itemStyle: { color: '#8caabe' }
            },
            {
              name: '90%', icon: 'rect', itemStyle: { color: '#f5999a' }
            },
            {
              name: 'close50%',
            },
            {
              name: '50%'
            },

          ],
        },
        series: [
          // 开环10%
          {
            name: '10%',
            type: 'line',
            data: this.AGPGraphList['open']['T1Data'],
            stack: 'open',
            lineStyle: {
              normal: {
                color: '#f5999a',
                width: 1
              }
            },
            symbol: 'none',
            markLine: {
              data: [{ yAxis: 3.9 }, { yAxis: 10 }],
              silent: true,
              symbol: ['circle', 'circle'],
              symbolSize: 1,
              lineStyle: {
                normal: {
                  color: 'black',
                  type: [5, 10],
                  dashOffset: 5,
                  width: 1,
                }
              },
              label: { normal: { show: false } },
            },
          },
          // 开环50%
          {
            name: '50%',
            type: 'line',
            data: this.AGPGraphList['open']['midData'],
            lineStyle: {
              normal: {
                color: '#f5999a',
                width: 2
              }
            },
            symbol: 'none',
          },
          // 开环90%
          {
            name: '90%',
            type: 'line',
            data: this.AGPGraphList['open']['T9Data'],
            stack: 'open',
            areaStyle: { normal: { color: '#f5999a', } },
            lineStyle: {
              normal: {
                color: '#f5999a',
                width: 1
              }
            },
            symbol: 'none',
          },
          // 闭环10%
          {
            name: 'close10%',
            type: 'line',
            data: this.AGPGraphList['close']['T1Data'],
            stack: 'close',
            lineStyle: {
              normal: {
                color: '#8caabe',
                width: 1
              }
            },
            symbol: 'none',
          },
          // 闭环50%
          {
            name: 'close50%',
            type: 'line',
            data: this.AGPGraphList['close']['midData'],
            lineStyle: {
              normal: {
                color: '#8caabe',
                width: 2,
                type: 'dashed'
              }
            },
            symbol: 'none',
          },
          // 闭环90%
          {
            name: 'close90%',
            type: 'line',
            data: this.AGPGraphList['close']['T9Data'],
            stack: 'close',
            areaStyle: { normal: { color: '#8caabe', } },
            lineStyle: {
              normal: {
                color: '#8caabe',
                width: 1
              }
            },
            symbol: 'none',
          },

        ]
      })

    },
    drawComparison (comparisonList, id) {
      let maxY = 100, Yname = 'Percent of Time with Glucose \n3.9-10mmol/L'
      let maxX = comparisonList.Q2Data[comparisonList.Q2Data.length - 1][0] + 1
      let baseLineAvg = [comparisonList.avgData.shift()]
      let baseLineQ2 = [comparisonList.Q2Data.shift()]
      if (id.match(/TBR/g)) {
        maxY = 10
        Yname = 'Percent of Time with Glucose \n<3.9mmol/L'
      }
      this.comparisonChart = echarts.init(document.getElementById(id))
      this.comparisonChart.setOption({
        xAxis: [{
          type: 'value',
          name: 'Weeks',
          min: 0,
          max: maxX,
          interval: 0.5,
          nameTextStyle: {
            color: '#282828'
          },
          splitLine: {
            show: false
          },
          axisLabel: {
            margin: 15, textStyle: { color: '#282828', baseline: 'middle', fontSize: 16 },
            formatter: function (value, index) {
              if (value === 0) {
                return '0'
              } else if (value === 1) {
                return 'Baseline'
              } else if (parseInt(value) === value) {
                return (value - 1) * 4 - 3 + '-' + (value - 1) * 4
              }
            },
          },
          axisTick: {
            show: true,
          },
          nameLocation: 'middle',
          nameGap: 25,
          nameTextStyle: {
            fontSize: 18,
            color: 'black'
          },
        }],
        yAxis: [
          {
            type: 'value',
            min: 0,
            max: maxY,
            show: true,
            name: Yname,
            nameLocation: 'middle',
            nameTextStyle: {
              color: '#282828'
            },
            nameGap: 30,
            nameTextStyle: {
              fontSize: 18,
              color: 'black'
            },
            axisLabel: {
              margin: 8,
              textStyle: { color: '#282828', baseline: 'middle', fontSize: 16 }
            },
            splitNumber: 10,
            splitLine: {
              show: false
            },
          },
        ],
        legend: {
          top: '10%',
          itemHeight: 5,
          itemStyle: {
            borderWidth: 2,
            borderType: 'solid',
          },
          formatter: function (name) {
            let nameLegendMap = new Map([
              ['75%', 'Control (N=56)'],
              ['close75%', 'Closed loop (N=112)']
            ])
            return nameLegendMap.get(name)
          },
          data: [
            {
              name: 'close75%', icon: 'roundRect', itemStyle: { color: '#8caabe', borderColor: '#8caabe' }
            },
            {
              name: '75%', icon: 'roundRect', itemStyle: { color: '#f5999a', borderColor: '#f5999a' }
            },
          ],
        },
        series: [
          // 开环25%
          {
            name: '25%',
            type: 'custom',
            stack: 'open',
            itemStyle: {
              borderColor: 'white',
              color: 'white'
            },
            data: comparisonList.Q1Data,
            zlevel: -1,
            renderItem: function (params, api) {
              let y = api.value(1);
              let start = api.coord([api.value(0), y]);
              let size = api.size([1, y]);
              let style = api.style()
              return {
                type: 'rect',
                shape: {
                  x: start[0] - 1,
                  y: start[1],
                  width: size[0] / 2 + 2,
                  height: size[1],
                },
                style: style,
              }
            },
          },
          // 开环75%
          {
            name: '75%',
            stack: 'open',
            type: 'custom',
            itemStyle: {
              color: '#f5999a',
              borderColor: 'white'
            },
            data: baseLineQ2,
            zlevel: -999,
            renderItem: function (params, api) {
              let y = api.value(1);
              let start = api.coord([api.value(0), y]);
              let size = api.size([1, y]);
              let style = api.style()
              return {
                type: 'rect',
                shape: {
                  x: start[0],
                  y: start[1],
                  width: size[0] / 2,
                  height: size[1],
                },
                style: style,
              }
            },
          },
          // 开环均值
          {
            name: 'avg',
            type: 'line',
            data: baseLineAvg,
            symbol: 'circle',
            symbolSize: 6,
            itemStyle: {
              color: 'black'
            }
          },
          // 中值
          {
            name: '50%',
            type: 'line',
            data: comparisonList.midData,
            lineStyle: {
              normal: {
                color: 'black',
                width: 2,
              }
            },
            symbol: 'none',
          },
          // 闭环75%
          {
            name: 'close75%',
            type: 'custom',
            itemStyle: {
              color: '#8caabe',
              borderColor: 'white',
            },
            zlevel: -999,
            data: comparisonList.Q2Data,
            renderItem: function (params, api) {
              let y = api.value(1);
              let start = api.coord([api.value(0), y]);
              let size = api.size([1, y]);
              let style = api.style()
              return {
                type: 'rect',
                shape: {
                  x: start[0],
                  y: start[1],
                  width: size[0] / 2,
                  height: size[1],
                },
                style: style,
              }
            },
          },
          // 闭环均值
          {
            name: 'closeavg',
            type: 'line',
            data: comparisonList.avgData,
            symbol: 'circle',
            symbolSize: 6,
            lineStyle: {
              color: 'black',
              type: 'dashed'
            },
            itemStyle: {
              color: 'black'
            }
          },
        ]
      })
    },
    drawDistributionList () {
      let id = 'TIRDistribution'
      this.distributionChart = echarts.init(document.getElementById(id))
      this.distributionChart.setOption({
        xAxis: [{
          type: 'value',
          name: 'Time sensor glucose within target range(%)',
          nameTextStyle: {
            color: '#282828'
          },
          min: 0,
          max: 100,
          interval: 10,
          splitLine: {
            show: false
          },
          axisLabel: {
            margin: 15, textStyle: { color: '#282828', baseline: 'middle', fontSize: 16 },
          },
          nameLocation: 'middle',
          nameGap: 25,
          nameTextStyle: {
            fontSize: 18,
            color: 'black'
          },
        }],
        yAxis: [
          {
            type: 'value',
            min: 0,
            max: 100,
            interval: 20,
            show: true,
            name: 'Cumulative distribution(%)',
            nameLocation: 'middle',
            nameTextStyle: {
              color: '#282828'
            },
            nameGap: 30,
            nameTextStyle: {
              fontSize: 18,
              color: 'black'
            },
            axisLabel: {
              margin: 8,
              textStyle: { color: '#282828', baseline: 'middle', fontSize: 16 }
            },
            splitLine: {
              show: false
            },
          },
        ],
        tooltip: {
          show: true,
          trigger: 'axis',
          axisPointer: {
            type: 'line',
            axis: 'x',
            lineStyle: { color: '#333', }
          },
          backgroundColor: '#555',
          textStyle: {
            color: ' #ffffff',
            align: 'left'
          },
          formatter: (params) => {
            let tip = ''
            params.map(item => {
              tip += item.marker + this.TIRDistributionList[item.seriesName].nameList[item.dataIndex] + ': ' + item.value[0] + '%'
              tip += '<br/>'
            })
            return tip
          },
        },
        legend: {
          top: '10%',
          left: '15%',
          orient: 'vertical',
          formatter: function (name) {
            let nameLegendMap = new Map([
              ['open', 'Control'],
              ['close', 'Closed loop']
            ])
            return nameLegendMap.get(name)
          },
        },
        series: [
          // 开环
          {
            name: 'open',
            type: 'line',
            data: this.TIRDistributionList['open'].value,
            symbol: 'triangle',
            symbolSize: 8,
            itemStyle: {
              color: '#851b3d'
            }
          },
          // 闭环
          {
            name: 'close',
            type: 'line',
            data: this.TIRDistributionList['close'].value,
            symbol: 'circle',
            symbolSize: 6,
            itemStyle: {
              color: '#50a2bb'
            },
          },
        ]
      })
    },
    drawA1CDistribution () {
      let id = 'A1CDistribution'
      this.distributionChart = echarts.init(document.getElementById(id))
      this.distributionChart.setOption({
        xAxis: [{
          type: 'value',
          name: 'A1C(%)',
          min: 4,
          max: 10,
          interval: 1,
          axisLabel: {
            margin: 15, textStyle: { color: '#282828', baseline: 'middle', fontSize: 16 },
          },
          nameLocation: 'middle',
          nameGap: 25,
          nameTextStyle: {
            fontSize: 18,
            color: 'black'
          },
        }],
        yAxis: [
          {
            type: 'value',
            min: 0,
            max: 1,
            interval: 0.2,
            show: true,
            name: 'Cumulative distribution(%)',
            nameLocation: 'middle',
            nameTextStyle: {
              color: '#282828'
            },
            nameGap: 30,
            nameTextStyle: {
              fontSize: 18,
              color: 'black'
            },
            axisLabel: {
              margin: 8,
              textStyle: { color: '#282828', baseline: 'middle', fontSize: 16 }
            },
          },
        ],
        legend: {
          top: '15%',
          left: '15%',
          orient: 'vertical',
          borderType: 'solid',
          borderColor: 'black',
          borderWidth: '1',
          formatter: function (name) {
            let nameLegendMap = new Map([
              ['open', 'A1C(%)@baseline'],
              ['close', 'A1C(%)@study']
            ])
            return nameLegendMap.get(name)
          },
          data: [
            {
              name: 'open', icon: 'roundRect', itemStyle: { color: '#fd0301', borderColor: '#fd0301' }
            },
            {
              name: 'close', icon: 'roundRect', itemStyle: { color: '#0100c8', borderColor: '#0100c8' }
            },
          ],
        },
        grid: {
          show: true,
          borderColor: 'black'
        },
        tooltip: {
          show: true,
          trigger: 'axis',
          axisPointer: {
            type: 'line',
            axis: 'x',
            lineStyle: { color: '#333', }
          },
          backgroundColor: '#555',
          textStyle: {
            color: ' #ffffff',
            align: 'left'
          },
          formatter: (params) => {
            let tip = ''
            params.map(item => {
              tip += item.marker + this.A1CDistributionList[item.seriesName].nameList[item.dataIndex] + ': ' + item.value[0] + '%'
              tip += '<br/>'
            })
            return tip
          },
        },
        series: [
          // 开环
          {
            name: 'open',
            type: 'line',
            data: this.A1CDistributionList['open'].value,
            lineStyle: {
              width: 6,
              color: '#fd0301'
            },
            symbol: 'circle',
            symbolSize: 6,
            itemStyle: {
              color: '#fd0301'
            },
          },
          // 闭环
          {
            name: 'close',
            type: 'line',
            data: this.A1CDistributionList['close'].value,
            symbol: 'circle',
            symbolSize: 6,
            itemStyle: {
              color: '#0100c8'
            },
            lineStyle: {
              width: 6,
              color: '#0100c8'
            }
          },
        ]
      })
    },
    validateList (list) {
      if (list && list['open'] && list['open'].Q1Data.length) {
        return true
      } else {
        return false
      }
    },
    drawGraph () {
      if (this.validateList(this.AGPGraphList)) {
        this.drawAGPGraph()
        this.drawAGP19Graph()
      }
      // 计算TIR数据
      if (this.TIRComparisonList && this.TIRComparisonList.Q1Data.length) {
        this.drawComparison(this.TIRComparisonList, 'TIRComparison')
      }
      // 计算TBR数据
      if (this.TBRComparisonList && this.TBRComparisonList.Q1Data.length) {
        this.drawComparison(this.TBRComparisonList, 'TBRComparison')
      }
      // 计算TIR积累
      if (this.TIRDistributionList && this.TIRDistributionList.open.value.length) {
        this.drawDistributionList()
      }
      // 计算A1C积累
      if (this.A1CDistributionList && this.A1CDistributionList.open.value.length) {
        this.drawA1CDistribution()
      }
    },
    exportPDF () {
      var target = document.getElementsByClassName("graph")
      let promiseList = []
      let pdf = new jsPDF('1', 'pt', 'a4');
      let position = 20
      for (let i = 0; i < target.length; i++) {
        let promise = new Promise((resolve, reject) => {
          html2canvas(target[i]).then(canvas => {
            target[i].style.background = "#FFFFFF"
            let pageData = canvas.toDataURL('image/jpeg', 1.0)
            var contentWidth = canvas.width
            var contentHeight = canvas.height
            var imgWidth = 595.28
            var imgHeight = 592.28 / contentWidth * contentHeight

            if (i !== 0 && i % 2 === 0) {
              position = 20
              pdf.addPage()
              pdf.setPage(i / 2 + 1)
            }
            pdf.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
            position += imgHeight
            resolve()
          })
        })
        promiseList.push(promise)
      }
      Promise.all(promiseList).then(() => {
        pdf.save("graph.pdf", { returnPromise: true }).then((res) => {
          localStorage.removeItem('HCLGraph')
          setTimeout(() => {
            window.close()
          }, 500)
        })
      })
    },
  },
  mounted () {
    let graphData = JSON.parse(localStorage.getItem('HCLGraph'))
    if (graphData) {
      this.AGPGraphList = graphData.AGPGraphList
      this.TIRComparisonList = graphData.TIRComparisonList
      this.TIRDistributionList = graphData.TIRDistributionList
      this.TBRComparisonList = graphData.TBRComparisonList
      this.A1CDistributionList = graphData.A1CDistributionList
      this.drawGraph()
    }
  }
}
</script>
<style scoped>
.graphList {
  text-align: center;
  margin-left: 20%;
  width: 60%;
}
.graph {
  width: 800px;
  height: 500px;
  display: inline-block;
}
.btn {
  background-color: #0c544fff;
  border-color: #0c544fff;
  margin-left: 25%;
}
</style>



// WEBPACK FOOTER //
// HCLprint.vue?5fd764ba